import accounting from 'accounting'

export default function(score) {
    return accounting.toFixed(score, 4);
}